export const centsToMoney = (cents: number): string => (cents / 100).toFixed(2);
